import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDividerModule} from '@angular/material/divider';
import {MatBadgeModule} from '@angular/material/badge';
import {MatToolbarModule} from '@angular/material/toolbar'; 
import {MatPaginatorModule} from '@angular/material/paginator'; 
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSliderModule } from '@angular/material/slider';
import {MatStepperModule} from '@angular/material/stepper';
import  { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [],
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,

    MatRadioModule,
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatSelectModule,
    MatIconModule,

    MatCheckboxModule,
    MatTableModule,
    MatDialogModule,
    MatListModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatBadgeModule,
    MatToolbarModule,
    MatPaginatorModule,
    DragDropModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatTabsModule,
    MatSliderModule,
    MatStepperModule,
    MatChipsModule
  ],
  exports : [
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,

    MatRadioModule,
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatSelectModule,
    MatIconModule,

    MatCheckboxModule,
    MatTableModule,
    MatDialogModule,
    MatListModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatBadgeModule,
    MatToolbarModule,
    MatPaginatorModule,
    DragDropModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatTabsModule,
    MatSliderModule,
    MatStepperModule,
    MatChipsModule

  ]
})
export class MaterialModule { }

// import {NgModule} from '@angular/core';
